import { NgModule } from '@angular/core';
import { ZefTranslationsService } from '@zerops/zef/translations';
import { FEATURE_NAME } from './password-change-form.constant';

const en = {
  currentPassword: 'Current password',
  newPassword: 'New password',
  password: 'Password',
  minCharsHint: 'The password has to contain at least 8 characters.',
  maxCharsHint: 'Maximum password length is 72 characters.',
  safetyCheckHint: `Strength check on submit. Recommended 12+ characters.`
};

export type PasswordChangeFormTranslations = typeof en;

@NgModule()
export class PasswordChangeFormTranslationsModule {
  constructor(private _translationsService: ZefTranslationsService) {
    this._translationsService.setTranslations(FEATURE_NAME, { en });
  }
}
